export default __webpack_public_path__ + "static/media/ITSupport.293ea9fc.png";